<template>
  <div class="filter-index">
    <div class="row">
      <div class="wishlist">
        <ol class="card-list">
          <li class="card-list__item" v-for="item in items" :key="item.id">
            <FilterIndexItem :item="item" :wishlist-cookie-name="wishlistCookieName"></FilterIndexItem>
          </li>
        </ol>

        <div class="cta-holder">
          <button class="btn btn--alt" v-if="total >= visible" @click="loadMore" aria-label="Load more items" title="Click to load more items">Load more</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import FilterIndexItem from '@/vue/components/FilterIndexItem.vue';

export default {
  props: ['wishlistCookieName'],
  components: {
    FilterIndexItem
  },
  data() {
    return {
      items: [],
      visible: 0,
      total: 0,
      pageSize: 10
    };
  },
  watch: {
    visible() {
      axios
        .post('/umbraco/api/search/wishlist', {
          Take: this.visible
        })
        .then(response => {
          this.items = response.data.items;
          this.total = response.data.total;

          // update the query string with the take amount
          this.$router.replace({
            query: {
              Take: this.visible
            }
          });
        });
    }
  },
  created() {
    this.applyRouterData();
  },
  methods: {
    loadMore() {
      this.visible = this.visible + this.pageSize;
    },

    applyRouterData() {
      const currentRouteQuery = JSON.parse(
        JSON.stringify(this.$router.currentRoute.query)
      );
      this.visible = parseInt(currentRouteQuery.Take) || this.pageSize;
    }
  }
};
</script>